export const qaCompletedOrderLineStatusLookupId = 8;
export const clDeliveredOrderLineStatusLookupId = 9;
export const COMMERCIAL_PROPERTY_TYPE_ID = 2;
